module.exports = __webpack_public_path__ + "static/img/bianjie.df71fcff.png";